import {solid} from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import {Button, ButtonVariant} from '@ael/shared-components-library';

import './HintButton.scss';

export interface HintButtonProps {
  onClick: () => void;
}

export class HintButton extends React.PureComponent<HintButtonProps> {
  render() {
    return (
      <div className="hint-button">
        <Button
          variant={ButtonVariant.PRIMARY}
          icon={solid('info-circle')}
          onClick={(event) => {
            event.preventDefault();
            this.props.onClick();
          }}
        >
          HINT
        </Button>
      </div>
    );
  }
}
